module.exports = __webpack_public_path__ + "static/media/veneto-village-10.3caf2ef6.jpg";